/**
 * Helper to resolve media URLs (logos, banners, attachments)
 * Handles full URLs, data URIs, blob URIs, and relative backend storage paths.
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  return `${backendUrl}${trimmed.startsWith('/') ? '' : '/'}${trimmed}`;
}
